<template>
  <div class="base-control" :class="{[styleType]: true}">
    <button :class="buttonClass" :type="type" :disabled="disabled">
      <slot></slot>
    </button>
  </div>
</template>

<script>

export default {
  name: 'BaseButton',
  props: {
    label: {
      type: String,
      default: ''
    },
    componentClass: {
      type: String,
      default: ''
    },
    radius: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'button'
    },
    styleType: {
      type: String,
      default: 'd-inline-block'
    }
  },
  data () {
    return {

    };
  },
  mounted () {

  },
  computed: {
    id () {
      return 'base-button-' + this._uid;
    },
    buttonClass () {
      const d = {
        btn: true,
        'base-control': true,
        'base-button': true,
        [this.componentClass]: true,
        [this.radius]: true
      };

      return d;
    }
  },
  methods: {

  }
};

</script>

<style>
  .style-250{
    min-width: 240px;
  }
</style>
